/* eslint-disable max-len */
import React, {useEffect, useState, useRef} from 'react'
import {connect} from 'react-redux'
import Helpers from '../Helpers.js'

import Tiff from 'tiff.js'

// Actions
import {storePayload} from '../actions/storePayload'

// Components
import {Icon, Slider} from '@lazarusai/forms-ui-components'

// Styles
import stylesView from '../styles/View.module.css'
import stylesIndex from '../index.module.css'

function ImageRender(props) {
  const [fileURL, setFileURL] = useState(null)
  const [rotations, setRotations] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [imageWidth, setImageWidth] = useState(null)
  const [imageHeight, setImageHeight] = useState(null)
  const [isImageRendering, setIsImageRendering] = useState(false)
  // NOTE: TIFF PAGES ARE 0 INDEXED (PDFS ARE 1 INDEXED)
  const [pageNumber, _setPageNumber] = useState(0)
  const [pageNumberInput, _setPageNumberInput] = useState(1)
  const pageNumberInputRef = useRef(1)
  const pageNumberInputElRef = useRef()
  const [newDocPageCount, setNewDocPageCount] = useState(0)
  const [tiffPages, setTiffPages] = useState([])
  const pageNumberRef = useRef(0)
  const imageCanvasRef = useRef()
  const [imageRenderCounter, setImageRenderCounter] = useState(0)
  const [_selectedFileIndex, _setSelectedFileIndex] = useState(0)

  function setPageNumber(data) {
    _setPageNumber(data)
    if (tiffPages[data]) {
      setFileURL(tiffPages[data])
    }
    pageNumberRef.current = data
  }

  function setPageNumberInput(data) {
    _setPageNumberInput(data)
    pageNumberInputRef.current = data
  }

  function onFocusOut() {
    if (pageNumberInputRef.current !== pageNumberRef.current + 1) {
      onChangePageNum(pageNumberRef.current + 1)
    }
  }

  // Revert pageNumberInput back to valid number
  useEffect(() => {
    if (pageNumberInputElRef.current) {
      pageNumberInputElRef.current.removeEventListener('focusout', onFocusOut)
      pageNumberInputElRef.current.addEventListener('focusout', onFocusOut)
    }
  }, [pageNumberInputElRef, pageNumberInputElRef.current])

  useEffect(() => {
    if (!props.pagesData || Object.keys(props.pagesData).length === 0) {
      onChangePageNum(1)
    }
  }, [props.pagesData])

  useEffect(() => {
    onChangePageNum(1)
    _setSelectedFileIndex(props.selectedFileIndex)
  }, [props.selectedFileIndex])

  function onChangePageNum(num) { // expects positive num
    setPageNumberInput(num)
    const newPageNum = parseInt(num) - 1
    if (newPageNum >= 0 && newPageNum <= newDocPageCount - 1) {
      setPageNumber(newPageNum)
    }
  }

  // const fileIndex = 0 // file index placeholder

  const rotateStyles = [
    'rotate(0deg)',
    'rotate(90deg) translateY(-100%)',
    'rotate(180deg) translateY(-100%) translateX(-100%)',
    'rotate(270deg) translateX(-100%)',
  ]

  const smallRotateStyles = [
    'rotate(0deg)',
    'rotate(90deg) translateY(-100%)',
    'rotate(180deg) translateY(-100%) translateX(-100%)',
    'rotate(270deg) translateX(-100%)',
  ]

  // useEffect(() => {
  //   props.storePayload({
  //     isLoading: true,
  //   })
  // }, [])

  useEffect(() => {
    if (props.file) {
      if (props.file.type === 'image/tiff') {
        const xhr = new XMLHttpRequest()
        xhr.responseType = 'arraybuffer'
        xhr.open('GET', (window.URL || window.webkitURL).createObjectURL(props.file))
        xhr.onload = (e) => {
          try {
            const arrayBuffer = e.target.response
            Tiff.initialize({
              TOTAL_MEMORY: 16777216 * 10,
            })
            const tiff = new Tiff({
              buffer: arrayBuffer,
            })
            const numPages = tiff.countDirectory()
            const newTiffPages = []
            for (let i = 0; i < numPages; i++) {
              tiff.setDirectory(i)
              newTiffPages.push(tiff.toDataURL())
            }
            setTiffPages(newTiffPages)
            tiff.setDirectory(0)
            setNewDocPageCount(numPages)
            // setPageNumber(0)
            onChangePageNum(1)
            setRotations(0)
            setZoom(1)
            const maxWidth = document.getElementById('image-container').clientWidth
            // props.storePayload({
            //   srcHeight: tiff.height(),
            //   srcWidth: tiff.width(),
            // })
            const heightWidthRatio = tiff.height()/tiff.width()
            setIsImageRendering(true)
            setFileURL(tiff.toDataURL())
            setImageHeight(parseInt(maxWidth * heightWidthRatio))
            setImageWidth(maxWidth)
          } catch (error) {
            console.log(error)
            props.storePayload({
              userMessage: 'Your .tiff file had issues being opened. Make sure the file is not corrupted.',
              notificationType: 1,
              notificationIcon: 'warning',
            })
          }
        }
        xhr.send()
      } else {
        setNewDocPageCount(1)
        setRotations(0)
        setZoom(1)
        const fileReader = new FileReader()
        fileReader.readAsDataURL(props.file)
        fileReader.onload = (e) => {
          const image_obj = new Image()
          image_obj.src = e.target.result
          image_obj.onload = function() {
            const maxWidth = document.getElementById('image-container')?.clientWidth
            // props.storePayload({
            //   srcHeight: this.height,
            //   srcWidth: this.width,
            // })
            const heightWidthRatio = this.height/this.width
            setIsImageRendering(true)
            setFileURL(URL.createObjectURL(props.file))
            setImageHeight(parseInt(maxWidth * heightWidthRatio))
            setImageWidth(maxWidth)
          }
        }
      }
    }
  }, [props.file])

  useEffect(() => {
    const wrapEl = document.getElementById('doc-image-container')
    if (wrapEl) {
      wrapEl.style.height = `${rotations % 2 === 0 ? imageHeight * zoom : imageWidth * zoom}px`
      wrapEl.style.width = `${rotations % 2 === 0 ? imageWidth * zoom : imageHeight * zoom}px`
    }
  }, [rotations, zoom])

  function initiateDrawBoxes() {
    if (
      (props.formsResponses?.[props.selectedFileIndex]?.ocrResults?.readResults ||
        (props.srcHeight && props.srcWidth)
      ) && // needed for dimensions
      props.pagesData?.[props.selectedFileIndex]?.[pageNumber + 1]?.values?.length > 0
    ) {
      const canvasEl = document.getElementById('image-canvas-keyValuePairs-' + props.selectedFileIndex)
      if (canvasEl) {
        const context = canvasEl.getContext('2d', {willReadFrequently: true})
        context.clearRect(0, 0, canvasEl.width, canvasEl.height)
        const drawBoxesProps = {
          res: props.formsResponses[props.selectedFileIndex],
          file: props.file,
          pagesData: props.pagesData[props.selectedFileIndex],
          pageNumber: pageNumber + 1,
          fileIndex: props.selectedFileIndex,
          rotations,
          zoom,
          srcHeight: props.srcHeight,
          srcWidth: props.srcWidth,
          // srcHeight: props.srcHeight * (props.file.type === 'image/tiff' ? 4.125 : 300),
          // srcWidth: props.srcWidth * (props.file.type === 'image/tiff' ? 4.125 : 300),
        }
        // console.log('initiate db 3', drawBoxesProps)
        Helpers.drawBoxes(drawBoxesProps)
      }
    }
  }

  useEffect(() => {
    setTimeout(() => { // render after model response
      initiateDrawBoxes()
    }, [0])
  }, [props.pagesData])

  useEffect(() => { // render for when page changes or selected image changes
    setTimeout(() => {
      initiateDrawBoxes()
    }, [0]) // timeout is still needed to make sure all state values are updated
  }, [pageNumber, imageRenderCounter, imageCanvasRef.current])

  // for some reason, boxes aren't drawn without a delay even though it seems the canvas is rendered
  // useEffect(() => {
  //   setTimeout(() => {
  //     console.log('///////////////')
  //     initiateDrawBoxes()
  //   }, [100])
  // }, [props.selectedFileIndex])

  return (
    <div className={stylesView['render-container']}>
      <div className={`${stylesView['zoom']}`}>
        <Slider
          type={4}
          theme={'dark'}
          onChangeZoom={(e) => {
            const val = parseInt(e.target.value)
            setZoom(3 ** (val/50) / 3)
          }}
        />
      </div>
      {props?.file?.type === 'image/tiff' &&
        <div
          className={`${stylesView['arrow-left']} ${stylesView['arrow']}`}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            if (pageNumberInputRef.current - 1 > 0) {
              onChangePageNum(pageNumberInputRef.current - 1)
            }
          }}
        >
          {
            pageNumberInputRef.current - 1 > 0 ?
              <Icon
                icon={'arrow-circle-left-outline'}
                key={'arrow-left'}
                animation={null}
              /> :
              <Icon
                className={
                  `${stylesIndex['disabled']}`
                }
                icon={'arrow-circle-left-outline'}
                key={'arrow-left-disabled'}
                animation={null}
              />
          }
        </div>
      }
      {props?.file?.type === 'image/tiff' && newDocPageCount > 1 &&
            <div className={`${stylesView['page-number-pill']}`}>
              <span className={`${stylesView['page-number-pill-span']}`}>
                <input
                  className={stylesView['page-number-input']}
                  onChange={(e) => onChangePageNum(e.target.value)}
                  value={pageNumberInput}
                  type='number'
                  max={newDocPageCount}
                  min={0}
                  width='auto'
                  ref={pageNumberInputElRef}
                />
                <span>/</span>
                <span>{newDocPageCount}</span>
              </span>
            </div>
      }
      {props?.file?.type === 'image/tiff' &&
        <div
          className={`${stylesView['arrow-right']} ${stylesView['arrow']}`}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            if (pageNumberInputRef.current + 1 <= newDocPageCount) {
              onChangePageNum(pageNumberInputRef.current + 1)
            }
          }}
        >
          {
            pageNumberInputRef.current + 1 <= newDocPageCount ?
              <Icon
                icon={'arrow-circle-right-outline'}
                key={'arrow-right'}
                animation={null}
              /> :
              <Icon
                className={
                  `${stylesIndex['disabled']}`
                }
                icon={'arrow-circle-right-outline'}
                key={'arrow-right-disabled'}
                animation={null}
              />
          }
        </div>
      }
      <div
        className={`${stylesView['rotate-icon']}`}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setRotations((rotations + 1) % 4)
        }}
      >
        <Icon
          icon={'refresh-outline'}
          key={'rotate-icon'}
        />
      </div>
      <div id='image-container' className={`${stylesView['image-container']}`}>
        {props.file &&
            <div
              id={'pdf-keyValuePairs' + props.selectedFileIndex}
              style={{width: '100%'}}
            >
              {/* this is the image specific section */}
              <div
                className={`${stylesView['doc-image-container']}`}
                // onClick={onFileClick}
                id='doc-image-container'
              >
                <img
                  className={`${stylesView['rotate']}`}
                  src={fileURL}
                  alt=''
                  style={{
                    width: `${Math.round(zoom * imageWidth)}px`,
                    height: `${Math.round(zoom * imageHeight)}px`,
                    transform: `${rotateStyles[rotations]}`,
                    opacity: isImageRendering ? 0 : 1,
                  }}
                  onLoad={(e) => {
                    setIsImageRendering(false)
                    setImageRenderCounter((imageRenderCounter + 1) % 4)
                  }}
                />
                <canvas
                  key={`canvas-${fileURL}`}
                  id={'image-canvas-keyValuePairs-' + _selectedFileIndex}
                  ref={imageCanvasRef}
                  className={`${stylesView['image-canvas']} ${stylesView['rotate']} ${stylesView[(zoom < 1 ? 'small' : '')+'rotate'+rotations]}`}
                  height={Math.round(imageHeight)}
                  width={Math.round(imageWidth)}
                  style={{
                    // width: `${zoom * 100}%`,
                    height: `${Math.round(zoom * imageHeight)}px`,
                    width: `${Math.round(zoom * imageWidth)}px`,
                    transform: `${zoom < 1 ? smallRotateStyles[rotations] : rotateStyles[rotations]}`,
                  }}
                />
              </div>
            </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  pagesData: state.userReducer.pagesData,
  dataRender: state.userReducer.dataRender,
  srcHeight: state.userReducer.srcHeight,
  srcWidth: state.userReducer.srcWidth,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(ImageRender)

